import { render } from "./Audits.vue?vue&type=template&id=58c4a836&scoped=true&ts=true"
import script from "./Audits.vue?vue&type=script&lang=ts"
export * from "./Audits.vue?vue&type=script&lang=ts"

import "./Audits.vue?vue&type=style&index=0&id=58c4a836&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58c4a836"]])

export default __exports__